import defImg from '@/assets/images/decoration/img_default.png';
import defNavImg from '@/assets/images/decoration/nav_default.png';
import defBanner3 from '@/assets/images/decoration/banner_default_3.png';
import defBanner4 from '@/assets/images/decoration/banner_default_4.png';
import defBanner5 from '@/assets/images/decoration/banner_default_5.png';
import moment from 'moment';
import descripte from './descripte-filter';
import userInfo from './userInfo-filter';
import { getInternalReqUrl } from '@/utils/request';

const myFilter = {
  getImgById: function(id, isProxy = false, type = 'self') {
    // 转发图片 避免跨域, todo 需要通用
    const proxyTypeHost = {
      self: `/custom-system/py-file/`,
      alipay: `/custom-system/alipay-file/`,
    }[type];
    return id
      ? isProxy
        ? getInternalReqUrl(`${proxyTypeHost}${id}`)
        : serverConfig.imgBasicUrl + id
      : '';
  },
  // 获取默认图片
  getImgOrDefault: function(str) {
    return str || defImg;
  },
  // 获取店铺导航
  getNavImageDefault: function(str) {
    return str ? serverConfig.imgBasicUrl + str : defNavImg;
  },
  // 获取图片,如果没有就返回默认图片
  getImgByIdOrDefault: function(str) {
    return myFilter.getImgOrDefault(myFilter.getImgById(str));
  },
  // 获取banner 默认图
  getBannerDefaultImage: function(type) {
    switch (type) {
      case 3:
        return defBanner3;
      case 4:
        return defBanner4;
      case 5:
        return defBanner5;

      default:
        return defImg;
    }
  },

  commonStatus: function(v, statusList) {
    if (!statusList) return '';
    const item = statusList.find(t => t.value === v);
    return item ? item.label : '';
  },
  formatTime: function(str, xxF = 'YYYY-MM-DD HH:mm:ss') {
    return str > 0 ? moment(str).format(xxF) : '';
  },
  defaultQty: function(str) {
    return str || 0;
  },
  humanFileSize(bytes, si = true, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }

    const units = si
      ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (
      Math.round(Math.abs(bytes) * r) / r >= thresh &&
      u < units.length - 1
    );

    return bytes.toFixed(dp) + ' ' + units[u];
  },
};

// 根据ID获取图片
export default {
  ...myFilter,
  ...descripte,
  ...userInfo,
};
